import React from 'react'

import humps from 'humps'

import { Typography, Link, Collapse, makeStyles } from '@material-ui/core'

import Highlighter from 'components/Highlighter'
import styles from './styles'

const useStyles = makeStyles(styles)

const Changes = ({ log, field }) => {
  const classes = useStyles()
  const [open, setOpen] = React.useState(true)

  const handleClick = () => {
    setOpen(open => !open)
  }

  const Update = () =>
    Object.keys(log.auditedChanges).map(key => {
      return (
        <div className={classes.itemContainer} key={key}>
          <Typography className={classes.title}>
            Campo:{' '}
            <span className={classes.value}>
              <Highlighter
                textToHighlight={humps.decamelize(key)}
                searchWords={[field]}
              />
            </span>
          </Typography>

          <Typography className={classes.title}>
            Configuração anterior:{' '}
            <span className={classes.value}>
              {JSON.stringify(log.auditedChanges[key][0])}
            </span>
          </Typography>

          <Typography className={classes.title}>
            Configuração nova:{' '}
            <span className={classes.value}>
              {JSON.stringify(log.auditedChanges[key][1])}
            </span>
          </Typography>
        </div>
      )
    })

  const CreateOrDestroy = () =>
    Object.keys(log.auditedChanges).map(key => {
      return (
        <div className={classes.itemContainer} key={key}>
          <Typography className={classes.title}>
            Campo:{' '}
            <span className={classes.value}>
              <Highlighter
                textToHighlight={humps.decamelize(key)}
                searchWords={[field]}
              />
            </span>
          </Typography>

          <Typography className={classes.title}>
            Valor:{' '}
            <span className={classes.value}>
              {JSON.stringify(log.auditedChanges[key])}
            </span>
          </Typography>
        </div>
      )
    })

  return (
    <div className={classes.root}>
      <Typography>
        <Link className={classes.link} onClick={handleClick}>
          {open ? 'Ocultar detalhes' : 'Ver detalhes'}
        </Link>
      </Typography>

      <Collapse in={open}>
        <div className={classes.container}>
          {log.action === 'update' ? <Update /> : <CreateOrDestroy />}
        </div>
      </Collapse>
    </div>
  )
}

export default Changes
